<script setup lang="ts">
    import BaseTitle from '@/components/BaseTitle.vue';
    import TemplateCard from '@/components/TemplateCard.vue';
    import { EAppStep } from '@/typescript/enums/EAppStep';
    import useProductStore from '@/store/product.store';
    import { initProductImages } from '@/utils/productImage';
    import useStepper from '@/composables/useStepper';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import type { IProduct } from '@/typescript/interfaces/IProduct';

    const { productList, selectedProduct } = storeToRefs(useProductStore());
    const { goToStep } = useStepper();

    const filteredProductList = computed(() => {
        return productList.value.filter((product) => !product.prestashopUserId);
    });

    async function selectProduct(product: IProduct) {
        selectedProduct.value = product;
        selectedProduct.value = await initProductImages(product);
        goToStep(EAppStep.EDITION);
    }
</script>
<template>
    <div class="flex h-full w-full flex-col pt-4">
        <BaseTitle class="ml-6">{{ $t('template_selector_title') }}</BaseTitle>
        <div class="grid grow auto-rows-max grid-cols-3 gap-2 overflow-y-auto p-4">
            <TemplateCard
                v-for="product in filteredProductList"
                :key="product.id"
                :product
                @click="selectProduct(product)"
            />
        </div>
    </div>
</template>
